<template>
<div class='export-dialog'>
  <el-dialog :title="$t('actions.export.unpaid.title')" size="small" :visible.sync="orderDialogVisible" @close='close'>
    <p style='color:#333;'>{{$t('hint.project.export.main')}}</p>
    <p class='hint'>{{$t('hint.project.export.secondary')}}</p>
    <el-form v-if="exportsLeft === 0">
      <el-form-item :label="$t('common.order.labels.price')">
        ￥ 120 / {{$t('common.project')}}
        <a class='price-link' href='/price?closeOnPQuota=true' target='_blank'><i class='ppj-icon-gift'></i>升级账户，导出100个项目只需￥1999！</a>
      </el-form-item>
      <el-form-item :label="$t('common.order.labels.payType')">
        <el-radio-group theme='info' class='payment' v-model='payType'>
          <el-radio-button label='wechat'>{{$t('common.order.wechat')}}</el-radio-button>
          <el-radio-button label='alipay'>{{$t('common.order.alipay')}}</el-radio-button>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div class='has-quotas' v-else>
      <el-checkbox theme="info" :checked="true" :disabled="true">
        使用账号导出额度（{{exportsLeft === null ? '不限次数' : `还剩${exportsLeft}次`}}）
      </el-checkbox>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type='text' @click="orderDialogVisible = false">{{$t('common.buttons.cancel')}}</el-button>
      <el-button type="primary" @click="placeOrder()">{{$t('common.buttons.submit')}}</el-button>
    </div>
  </el-dialog>

  <el-dialog :title="$t('actions.export.paid.title')" size='small' :visible.sync="exportDialogVisible" @close='close'>
    <div class='export-content'>
      <div v-if="state === 'completed'">
        <a :href="archiveUrl" target="_blank" class='link'>点击链接下载</a>
        <p class='hint'>
          请用浏览器直接下载，暂不支持第三方下载工具。遇到问题请加QQ群：461571276，联系我们
        </p>
      </div>
      <div v-else-if="state === 'exceed_error'">
        <p><span class='danger'>注意：</span>您的导出额度已使用完毕</p>
        <p class='hint'>您可以新建项目，重新上传PPT源文件，并支付导出费用，来获得最新的导出文件。</p>
        <br />
        <br />
        <br />
        <p class='hint'>您仍然可以下载之前导出的文件，但该文件<span class='danger'>可能</span>与现在上传的源文件效果不一致</p>
        <a :href="`/projects/${project.id}/export?send_file=true`" target="_blank" class='link' style="font-size: 12px;">点击链接下载上次导出的文件</a>
        <p class='hint'>
          请用浏览器直接下载，暂不支持第三方下载工具。遇到问题请加QQ群：461571276，联系我们
        </p>
      </div>
      <div class='hint' v-else>
        <p><i class='ppj-icon-spinner' style='margin-right: 0.5em;'></i>服务器正在生成导出的zip包，请保持该页面打开，等待打包完成后下载。若长时间转化不成功，请加QQ群：461571276，联系我们
        </p>
      </div>
    </div>
  </el-dialog>
</div>
</template>

<script>
export default {
  data() {
    return {
      payType: 'wechat',
      orderDialogVisible: false,
      exportDialogVisible: false,
      formatType: 'html5',
      message: null,
      checkID: null,
      state: null,
      archiveUrl: null
    }
  },
  props: ['loading'],
  computed: {
    project() {
      return this.$store.state.project.items[this.$route.params.id]
    },
    exportsLeft() {
      return this.$store.state.quota.summary.exports_left
    }
  },
  methods: {
    initCheck() {
      let vm = this
      let check = () => {
        vm.$store.dispatch('project/checkExport', vm.project.id).then(res => {
          vm.clearCheck()
          vm.state = res.data.state
          if (vm.state === 'completed') {
            vm.archiveUrl = res.data.archive_url
          } else {
            vm.checkID = window.setTimeout(check, 2000)
          }
        })
      }

      check()
    },
    clearCheck() {
      let vm = this
      if (vm.checkID) {
        window.clearTimeout(vm.checkID)
      }
      vm.checkID = null
    },
    placeOrder() {
      let vm = this

      let success = () => {
        vm.createExportRequest()
      }

      if (vm.exportsLeft !== 0) {
        vm.$store.dispatch('quota/consume', {
          key: 'export',
          project_id: vm.project.id
        }).then(success)
      } else {
        vm.$order({
          package: 'one_time_export',
          project_id: vm.project.id,
          payment_method: vm.payType,
          success: success
        })
      }
    },
    createExportRequest() {
      let vm = this
      vm.$store.dispatch('project/createExport', {
        id: vm.project.id,
        export_format: vm.formatType
      }).then(res => {
        // 根据返回处理前端
        vm.state = res.data.state
        vm.archiveUrl = res.data.archive_url

        if (vm.state !== 'completed') {
          vm.initCheck()
        }

        vm.$emit('update:loading', false)
        // 此时应该打开Export-dialog 而不是下单 dialog
        vm.orderDialogVisible = false
        vm.exportDialogVisible = true
      }).catch(err => {
        vm.$emit('update:loading', false)

        let type = err.response.data.type
        if (type === 'ExceedExportAllowanceError') {
          vm.state = 'exceed_error'
          vm.message = err.response.data.message
          vm.orderDialogVisible = false
          vm.exportDialogVisible = true
        } else if (type === 'NoQuotaError') {
          // check quota to determine whether we can consume quota or not
          vm.$store.dispatch('refresh').then(_ => {
            vm.orderDialogVisible = true
            vm.exportDialogVisible = false
          })
        }
      })
    },
    open(formatType) {
      // need check status
      let vm = this
      vm.formatType = formatType
      //   vm.exportDialogVisible = true
      vm.$emit('update:loading', true)
      // create export
      vm.createExportRequest()
    },
    close() {
      this.clearCheck()
    }
  }
}
</script>

<style lang='scss' scoped>
.export-dialog {
    text-align: left;
    .payment {
        vertical-align: text-top;
    }

    .el-form-item {
        margin-bottom: 0;
    }

    .price-link {
        float: right;
        color: $color-primary;
        .ppj-icon-gift {
            margin-right: 0.4em;
        }
        &:focus,
        &:hover {
            color: lighten($color-primary, 10%);
        }
    }
}

.export-content {
    padding: 20px 0;
}
</style>



// WEBPACK FOOTER //
// export.dialog.vue?569669d9